import { OVERALL_PAGE_SUB_TYPE, PAGE_TYPE } from "../../../types/pages.type";

export const PAGE_CONVERTER_PAGE_TYPES = [
	PAGE_TYPE.HOSPITAL,
	PAGE_TYPE.COMMUNITY_TRANSFER,
	PAGE_TYPE.DECEASED,
];

export const PAGE_CONVERTER_PAGES = new Set(PAGE_CONVERTER_PAGE_TYPES);

function normalizeOverallTransferType(transferType) {
	if (transferType == null) return null;
	if (Array.isArray(transferType)) {
		const t = transferType[0];
		return t != null && String(t).trim() !== "" ? t : null;
	}
	if (typeof transferType === "string" && transferType.trim() === "") return null;
	return transferType;
}

/**
 * @param {string} page
 * @param {string|string[]|null|undefined} [transferType] — for Overall only: show converter when this is Total Outgoing
 */
export function isPageConverterPage(page, transferType) {
	if (PAGE_CONVERTER_PAGES.has(page)) return true;
	if (page === PAGE_TYPE.OVERALL) {
		return normalizeOverallTransferType(transferType) === OVERALL_PAGE_SUB_TYPE.TOTAL_OUTGOING;
	}
	return false;
}
